module.exports = __webpack_public_path__ + "img/1572980634.3a570b44.jpg";